import { IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

function BackButton({ onBack }) {
  return (
    <IconButton
      onClick={onBack}
      sx={{
        backgroundColor: 'rgba(0, 0, 0, 0.3)', // Semi-transparent background
        color: 'white', // White icon for contrast
        width: '40px', // Larger size
        height: '40px',
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.5)', // Darker on hover
        },
      }}
    >
      <ArrowBackIcon sx={{ fontSize: '30px' }} />

    </IconButton>
  );
}

export default BackButton;
